import React, { useState } from 'react';
import logo from '../../images/logo.svg';
import { Link } from 'gatsby';

const Header = (props) => {
  let woopra = null;
  if (typeof window !== 'undefined') {
    woopra = window.woopra || null;
  }
  const [menuActived, setMenuActive] = useState(false);

  const defaultSections = { productTour: false, features: false };
  const { productTour, features } = props.sections || defaultSections;
  const appUrl = process.env.GATSBY_APP_URL;
  const tasksUrl = process.env.GATSBY_TASKS_URL;

  const scrollTo = (ref) => {
    const el = ref.current;
    const headerTop = 50;
    window.scrollTo({
      top: el.offsetTop - headerTop,
      left: 0,
      behavior: 'smooth',
    });
  };

  const registerClick = function (ev, where) {
    if (woopra) {
      console.log('Goes to: ' + where);
      woopra.track('go_to_' + where);
    }
  };

  return (
    <header className="header">
      <nav className="navbar is-uppercase is-fixed-top" role="main">
        <div className="portica-wrapper is-fullhd">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <img src={logo} alt="logo" className="header__logo"></img>
              <h1 className="header__title is-inline-block is-size-5">
                Portica
              </h1>
            </Link>
            <span className="header-buttons">
              <a
                href={`${tasksUrl}`}
                className="button is-uppercase is-secondary is-small"
                onClick={(ev) => registerClick(ev, 'tasks')}
              >
                Tasks
              </a>

              <a
                href={`${appUrl}`}
                className="button is-uppercase is-primary is-small"
                onClick={(ev) => registerClick(ev, 'projects')}
              >
                Projects
              </a>
            </span>
          </div>
          <div
            id="top-navbar-menu"
            className={`navbar-menu ${menuActived ? 'is-active' : ''}`}
          >
            <div className="navbar-end is-size-6">
              <div className="navbar-item">
                {productTour && features && (
                  <span className="navbar-end__buttons">
                    <button
                      className="navbar-item remove-button-styles is-radiusless is-shadowless is-paddingless"
                      onClick={() => scrollTo(productTour)}
                    >
                      Product Tour
                    </button>
                    <button
                      className="navbar-item remove-button-styles is-radiusless is-shadowless is-paddingless"
                      onClick={() => scrollTo(features)}
                    >
                      Features
                    </button>
                  </span>
                )}

                <div className="buttons">
                  <a
                    href={`${tasksUrl}`}
                    className="button is-uppercase is-secondary"
                    onClick={(ev) => registerClick(ev, 'tasks')}
                  >
                    Go to Tasks
                  </a>

                  <a
                    href={`${appUrl}`}
                    className="button is-uppercase is-primary"
                    onClick={(ev) => registerClick(ev, 'projects')}
                  >
                    Go to My Projects
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
